import { EventInterface } from "@shop/frontend/web/js/interfaces/EventInterface";
import { eventHelper } from "@shop/frontend/web/js/helpers/EventHelper";
import { INITIAL_EVENT_ORDER } from "@shop/frontend/web/js/constants/event";
import { helpers } from "@shop/frontend/web/js/helpers";
import { EventInteractPlan } from "../components/EventInteractPlan/EventInteractPlan";
import { arrayHelper } from "@shop/frontend/web/js/helpers/ArrayHelper";
import api from "@shop/frontend/web/js/api";
import { translator } from "@shop/frontend/web/js/services/TranslatorService";
import { Modal } from "@shop/frontend/web/js/components/Modal";

import { EventView } from "@frontend/src/js/views/EventView";
import { EventOrderBottom } from "@frontend/src/js/components/EventOrderBottom/EventOrderBottom";

class EventController extends EventInterface {
	constructor() {
		super();

		/* Объявляем компоненты */
		this.interactPlan = new EventInteractPlan();
		this.eventOrderBottom = new EventOrderBottom();
		this.modal = new Modal();

		/* Создаем представления */
		this.view = new EventView();

		/* Инициализация событии */
		super.initEventEmitter();
	}

	hasServicesWithoutTickets(orderItems) {
		const hasAnyServices = orderItems.some(item =>
			item.additionalServices?.length > 0
		);

		const hasAnyTickets = orderItems.some(item =>
			item.additionalTickets?.length > 0
		);

		return hasAnyServices && !hasAnyTickets;
	}

	checkAddedService() {
		const ticketsItems = $('.tickets__items');
		const hasAddService = ticketsItems.find('.additional-services__add-service').length > 0;
		const hasAddedService = ticketsItems.find('.additional-services__added-service').length > 0;

		return hasAddService && !hasAddedService;
	}

	showServiceNotification() {
		$('.tickets__notification').addClass('active');
		$('.tickets__notification_mobile').addClass('active');
	}

	hideServiceNotification() {
		$('.tickets__notification').removeClass('active');
		$('.tickets__notification_mobile').removeClass('active');
	}

	/* Инициализция подписчиков */
	setUpSubscribers() {
		/**
		 * Подписчик который срабатывает после загрузки мероприятия
		 * @event EventController#event:after-load-event
		 */
		this.emitter.subscribe("event:after-load-event", () => {
			/* добавляем в модель информацию об евенте */
			this.model.setEventId(this.view.$placesContainer.data("event"));
			this.model.unitId = $("#js-svg").data("unit");
			this.model.settings.validateAndAddSettings(this.view.getPlacesSettings());

			if (this.model.settings.hasChildTicket) {
				this.view.showChildTicketInfo();
			}

			if (window.location.pathname.includes("event") && !helpers.isDesktop.matches)
				this.view.showEventOnPopup();

			if (INITIAL_EVENT_ORDER)
				this.eventOrderBottom.updateOrder(INITIAL_EVENT_ORDER, this.model.getEventId());

			/* Инициализируем работу с планом */
			this.interactPlan.init({
				model: {
					eventId: this.model.getEventId(),
					unitId: this.model.unitId,
				},
				settings: this.model.settings.getSettings(),
				onLoadStadium: () => {
					this.model.currentViewId = null;
					//На случаи когда в плане отображаются одновременно места
					this.interactPlan.setActivePlaces(this.eventOrderBottom.getOrderCarts());
				},
				onLoadSector: ({ viewId }) => {
					this.model.currentViewId = viewId;
					this.interactPlan.setActivePlaces(this.eventOrderBottom.getOrderCarts());
				},
				tapOnPlace: place => tapOnPlaceHandler(place),
			});

			if (eventHelper.isStadiumPlan()) {
				api.event.getZones({ eventId: this.model.getEventId() }).then(res => {
					if (!res.zones) return this.modal.show(`Не удалось получить ценовые зоны!`);
					this.model.zones = arrayHelper.convertObjectToArray(res.zones);
					this.model.zones = this.model.removeZeroPriceZones(this.model.zones);
					this.interactPlan.renderStadiumPriceLegend(this.model.zones);
				});
			} else {
				this.interactPlan.svgPlacesManager
					.updateSvgPlacesHandler(this.model.eventId)
					.then(res => {
						if (!res.svg) return alert("Не удалось загрузить схему сектора!");
						if (!res.zones) return alert("Не удалось загрузить ценовые зоны!");

						this.interactPlan.view.renderSvgPlan(res.svg);
						$(".places__svg").addClass("skeleton-loader");
						this.interactPlan.initSectorPlan();

						this.interactPlan.showSectorZonesLoader();

						this.interactPlan.svgPlacesManager
							.getPrices(this.interactPlan.model.eventId)
							.then(({ prices, zones }) => {
								this.interactPlan.model.zones = zones;
								this.interactPlan.model.prices = prices;
								this.interactPlan.updatePlacesPrices({
									places_params: res.places_params,
								});
								$(".places__svg").removeClass("skeleton-loader");
								this.interactPlan.emitter.emit("event:after-load-sector", {
									...res,
									prices,
								});
							});
					})
			}
		});

		/**
		 * При нажатии на активное место добавляет
		 * или удаляет из корзины и возвращает событие
		 * @property {SVGGElement} $activePlace
		 */
		const tapOnPlaceHandler = $activePlace => {
			const sid = $activePlace.attr("id");
			const uid = $activePlace.attr("uid");
			const priceId = $activePlace.attr("price-id");

			/* Если место уже активное то удаляем из корзины */
			if ($activePlace.attr("data-available") === "false")
				return this.emitter.emit("event:remove-from-cart", { sid, uid, priceId });

			return this.emitter.emit("event:add-to-cart", sid);
		};

		/**
		 * Удаляет место из корзины
		 * @event EventController#event:remove-from-cart
		 */
		this.emitter.subscribe("event:remove-from-cart", ({ sid, uid, priceId }) => {
			return api.eventCart
				.removeFromCart({
					eventId: this.model.eventId,
					sid: sid,
					viewId: this.model.currentViewId,
				})
				.then(res => {
					if (res.error) throw new Error(res.msg);
					if (res.redraw)
						return this.modal.show("Данное место больше недоступно. Выберите другое.");
					if (!res.carts) return false;

					window.CartService.count = window.CartService.count - 1;
					window.CartService.updateCount();

					this.eventOrderBottom.removeActiveCarts(res.carts);
					this.interactPlan.removeActivePlaces(res.carts);
				})
				.catch(err =>
					this.modal.show(
						`
						${translator.t("main", "An error occurred when deleting from the basket!")}
						<p>${err.message}</p>
						`
					)
				).finally(() => {
					if (this.checkAddedService()) {
						this.showServiceNotification()
					} else {
						this.hideServiceNotification()
					}
				})
		});

		/**
		 * Подписчик который добавляет место в корзину
		 * @event EventController#event:add-to-cart
		 */
		this.emitter.subscribe("event:add-to-cart", sid => {

			api.eventCart
				.addToCart({
					eventId: this.model.eventId,
					sid: sid,
					viewId: this.model.currentViewId,
				})
				.then(res => {
					if (res.error) {
						const msg = res.msg === 'Требуется авторизация'
						  ? translator.t('event', 'To place an order, you need to register on the site or log in.') : res.msg;
			
						if (res.msg === 'Требуется авторизация') {
						  $('#loginModal').modal('show');
						  $('#loginModal').css('z-index', '111111');
						  return;
						}
			
						return this.modal.show(msg);
					}
		
					if (res.need_auth) {
						return this.modal.show(translator.t('main', 'Authorization required!'));
					}
					
					if (res.limit)
						return this.modal.show(
							translator.t(
								"event",
								"You have exceeded the maximum number of places for booking"
							)
						);
					if (res.redraw) {
						this.interactPlan.loadPlacesPrices({
							viewId: this.model.currentViewId,
							clearCache: true,
						});
						return this.modal.show("Данное место больше недоступно. Выберите другое.");
					}
					if (res.error) return this.modal.show(res.msg);

					/* Обновляем счетчик корзины */
					window.CartService.count = window.CartService.count + 1;
					window.CartService.updateCount();

					const urlParams = new URLSearchParams(window.location.search);
					const idEventFromUrl = Number(urlParams.get('id_event'));
					const filteredCarts = res.allCarts.filter(cart => cart.event_id === idEventFromUrl);

					const order = {
						carts: filteredCarts,
						id: res.order.id,
						additionalServices: res.additionalServices,
					}

					if (this.hasServicesWithoutTickets(filteredCarts)) {
						$('.tickets__notification').addClass('active');
						$('.tickets__notification_mobile').addClass('active');
					} else {
						$('.tickets__notification').removeClass('active');
						$('.tickets__notification_mobile').removeClass('active');
					}

					/* Выводим заказ */
					this.eventOrderBottom.updateOrder(order, this.model.getEventId());
					/* Показываем активные места на плане */
					this.interactPlan.setActivePlaces(this.eventOrderBottom.getOrderCarts());
				})
				.catch(err => {
					this.modal.show(
						`
						${translator.t("main", "An error occurred when adding to the basket!")}
						<p>${err.message}</p>
						`
					);
				});
		});

		/**
		 * Делает запрос на очистку корзины
		 * @event EventController#event:clear-cart
		 */
		this.emitter.subscribe("event:clear-cart", () => {
			api.eventCart
				.removeEventFromOrder({
					eventId: this.model.eventId,
					orderId: this.eventOrderBottom.getOrderId(),
				})
				.then(res => {
					if (res.error)
						return this.modal.show(res.msg ? res.msg : "Неизвестная ошибка!");

					if (res.refresh) return window.location.reload();

					if (!res.success)
						return this.modal.show(
							`${translator.t(
								"main",
								"An error occurred when deleting from the basket!"
							)}`
						);

					/* Очищаем активные места на плане */
					this.interactPlan.removeActivePlaces(this.eventOrderBottom.getOrderCarts());

					/* Очищаем корзину */
					this.eventOrderBottom.clearOrder();
				})
				.catch(err =>
					this.modal.show(
						`${translator.t(
							"main",
							"An error occurred when deleting from the basket!"
						)}`
					)
				);
		});
	}

	/* Инициализция обработчиков */
	setUpListeners() {
		this.eventOrderBottom.on("clear", () => this.emitter.emit("event:clear-cart"));
		this.eventOrderBottom.on("remove-ticket", ({ sid, uid, priceId }) =>
			this.emitter.emit("event:remove-from-cart", { sid, uid, priceId })
		);

		if (!helpers.isDesktop.matches) {
			this.eventOrderBottom.pane("show", () =>
				$("#js-places-change").css("padding-bottom", "138px")
			);
			this.eventOrderBottom.pane("hide", () =>
				$("#js-places-change").css("padding-bottom", "0")
			);
		}

		$(window).on("resize", () => {
			if (!helpers.isDesktop.matches) {
				if (this.view.$popupModal && this.view.$popupModal.hasClass("i-modal_mobile-fixed"))
					return true;
				return this.view.showEventOnPopup();
			}

			if (this.view.$popupModal && this.view.$popupModal.hasClass("i-modal_mobile-fixed"))
				return this.view.returnEventFromPopup();

			return true;
		});

		/* Инициализация страницы евента */
		this.emitter.emit("event:after-load-event");
	}
}

export const eventController = new EventController();
